<script setup lang="ts">
import { useCssModule } from "vue";

import BackStepButton from "@/components/BackStepButton/BackStepButton.vue";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { I_WIDGET_STEPS } from "@/stores/tiw/tiw.types";
import Button from "@/ui/button/button.vue";

interface Props {
    clickToNext: () => void | Promise<void>;
    onBack?: () => void | Promise<void>;
    loading?: boolean;
    disabled?: boolean;
    btnText?: string;
    stepToReturn?: I_WIDGET_STEPS;
    noBackBtn?: boolean;
}
const {
    clickToNext,
    onBack,
    loading,
    disabled,
    btnText,
    stepToReturn,
    noBackBtn = false,
} = defineProps<Props>();

const classes = useCssModule();
</script>

<template>
    <div data-component="StepsButtons" :class="classes.buttonsContainer">
        <slot name="backStepBtn" v-if="noBackBtn === false" :className="classes.btnBackStep">
            <BackStepButton
                :on-back="onBack"
                :step-to-return="stepToReturn"
                :class="classes.btnBackStep"
            />
        </slot>
        <slot name="additionalBtn"></slot>
        <!-- TODO рефакторинг стилизации -->
        <Button
            type="button"
            :disabled="disabled"
            :loading="loading"
            class="tiw__step__chooseDevice__btn-next"
            @click="clickToNext"
        >
            <span>
                {{ btnText || useTranslate("tiw__continue") }}
            </span>
        </Button>
    </div>
</template>
<style module>
.buttonsContainer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    margin-top: 24px; /* FIXME убери этот отступ. Комопнент не должен знать, куда его встраивают. Все внешние отступы даёт родитель */
}
.btnBackStep {
    margin-right: auto;
}
</style>
